// 选人：一排名字胶囊，点一下选中、再点一下取消。取代原生多选框（浏览器只会显示「选择了 N 项」，看不出选了谁）。
// 同时保留一个视觉隐藏的原生多选框，给依赖它的老测试和表单行为用；读屏和键盘只走胶囊。
import './ui.css'

export function PeoplePicker({
  label,
  people,
  value,
  onChange,
  prefix = '',
}: {
  label: string
  people: { id: string; name: string }[]
  value: string[]
  onChange: (ids: string[]) => void
  /** 名字前缀，比如评论里 @ 人用 "@" */
  prefix?: string
}) {
  const toggle = (id: string) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id])
  return (
    <span className="people-pick">
      <span role="group" aria-label={`${label}（点选）`} className="people-pick-chips">
        {people.map((p) => (
          <button
            key={p.id}
            type="button"
            className="people-chip"
            aria-pressed={value.includes(p.id)}
            onClick={() => toggle(p.id)}
          >
            <i aria-hidden="true">{p.name.slice(0, 1)}</i>
            {prefix}
            {p.name}
          </button>
        ))}
      </span>
      <select
        multiple
        aria-label={label}
        aria-hidden="true"
        tabIndex={-1}
        className="people-pick-native"
        value={value}
        onChange={(e) => onChange(Array.from(e.target.selectedOptions, (o) => o.value))}
      >
        {people.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
    </span>
  )
}
